import { moduleType, subModuleType } from "./module-types";

export enum apiEndpoints {
    // authentication
    signUp = moduleType.authentication + subModuleType.signup,
    organizationCreate = moduleType.authentication + subModuleType.organization_create,
    validateUser = moduleType.authentication + subModuleType.validate_user,
    signIn = moduleType.authentication + subModuleType.signin,
    token = moduleType.authentication + subModuleType.token,
    refresh = moduleType.authentication + subModuleType.token + subModuleType.refresh,
    signOut = moduleType.authentication + subModuleType.signout,
    signOutAllDevice = moduleType.authentication + subModuleType.signout_all_device,
    forgotPassword = moduleType.authentication + subModuleType.reset_email,
    resetPassword = moduleType.authentication + subModuleType.reset_password,
    changePassword = moduleType.authentication + subModuleType.change_password,
    fcmToken = moduleType.authentication + subModuleType.fire_base,
    subscribeToken = subModuleType.subscribe_fcm,
    unSubscribeToken = subModuleType.unsubscribe_fcm,
    userGroup = moduleType.authentication + subModuleType.ddl + subModuleType.user_group,
    orgList = moduleType.authentication + subModuleType.organization,
    orgaSelection = moduleType.authentication + subModuleType.organization_selection,
    get_user_organization_filter = subModuleType.get_user_organization_filter,
    set_user_organization_filter = subModuleType.set_user_organization_filter,
    user_login_history = moduleType.authentication + subModuleType.user_login_history,
    // ddl
    payment_terms_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.payment_terms,
    organizer_console_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.settings_dropdown,
    supplier_ddl = moduleType.interactions + subModuleType.ddl + subModuleType.supplier,
    tax_on_quotes_invoice_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.tax_on_iq,
    tax_on_purchase_order_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.tax_on_po,
    job_category_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.job_category,
    cost_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.cost,
    invoice_payment_mode = moduleType.worksheet + subModuleType.ddl + subModuleType.invoice_payment_mode,
    // costtype_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.cost_type,
    costtype_ddl = moduleType.worksheet + subModuleType.ddl + subModuleType.cost_type,
    state_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.states,
    country_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.country,
    task_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.task,
    currency_ddl = moduleType.worksheet + subModuleType.ddl + subModuleType.currency,
    roles_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.roles,
    round_unit_price = moduleType.worksheet + subModuleType.ddl + subModuleType.round_unit_price,
    address_type = moduleType.interactions + subModuleType.ddl + subModuleType.address_type,
    email_template_type = moduleType.worksheet + subModuleType.ddl + subModuleType.email_template_types,
    template_type_variable = moduleType.worksheet + subModuleType.ddl + subModuleType.template_type_variable,
    timesheet_rate_source = moduleType.worksheet + subModuleType.ddl + subModuleType.timesheet_rate_source,
    client_job = moduleType.collaboration + subModuleType.ddl + subModuleType.job,
    timesheet_status =  moduleType.worksheet + subModuleType.ddl + subModuleType.timesheet_status,
    cost_sell_type = moduleType.organizer_console + subModuleType.ddl + subModuleType.cost_sell_type,
    due_creteria = moduleType.worksheet + subModuleType.ddl + subModuleType.due_creteria,
    job_template_phase_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.job_template_phase,

    
    //Organization
    organization = moduleType.organizer_console + subModuleType.organization_settings,
    time_zone = moduleType.worksheet + subModuleType.ddl + subModuleType.time_zone,
    organizer_margin = moduleType.organizer_console + subModuleType.uplift_margin,
    organization_detail = moduleType.organizer_console + subModuleType.organization_detail,

    // client-type
    client_type = moduleType.organizer_console + subModuleType.client_type,
    multiple_client_type_delete = moduleType.organizer_console + subModuleType.multiple_client_type_delete,

    // number_sequence
    number_sequence = moduleType.organizer_console + subModuleType.number_sequence,

    // job-settings
    job_category = moduleType.organizer_console + subModuleType.job_category,
    job_states = moduleType.organizer_console + subModuleType.job_states,
    job_template = moduleType.organizer_console + subModuleType.job_template,
    default_job_states_colors = moduleType.organizer_console + subModuleType.default_job_states_colors,
    multiple_job_category_delete = moduleType.organizer_console + subModuleType.multiple_job_category_delete,
    multiple_job_states_delete = moduleType.organizer_console + subModuleType.multiple_job_states_delete,
    multiple_job_template_delete = moduleType.organizer_console + subModuleType.multiple_job_template_delete,
    multiple_job_template_phase_delete = moduleType.organizer_console + subModuleType.multiple_job_template_phase_delete,
    multiple_job_template_milestone_delete = moduleType.organizer_console + subModuleType.multiple_job_template_milestone_delete,

    job_template_task_reoder = moduleType.organizer_console + subModuleType.job_template_task_reoder,
    job_template_cost_reoder = moduleType.organizer_console + subModuleType.job_template_cost_reoder,
    job_template_phase_reorder = moduleType.organizer_console + subModuleType.job_template_phase_reorder,
    job_template_milestone_reorder = moduleType.organizer_console + subModuleType.job_template_milestone_reorder,
    job_template_phase =  moduleType.organizer_console + subModuleType.job_template_phase,
    job_template_milestone = moduleType.organizer_console + subModuleType.job_template_milestone,


    // roles
    roles = moduleType.organizer_console + subModuleType.roles,
    privileges = moduleType.organizer_console + subModuleType.privileges,
    multiple_roles_delete = moduleType.organizer_console + subModuleType.multiple_roles_delete,

    // job-template
    job_template_list = moduleType.organizer_console + subModuleType.job_template,
    create_template = moduleType.organizer_console + subModuleType.job_template,
    create_task = moduleType.organizer_console + subModuleType.job_template_task,
    create_cost = moduleType.organizer_console + subModuleType.job_template_cost,
    multiple_job_template_task_delete = moduleType.organizer_console + subModuleType.multiple_job_template_task_delete,
    multiple_job_template_cost_delete = moduleType.organizer_console + subModuleType.multiple_job_template_cost_delete,
    //cost
    cost = moduleType.organizer_console + subModuleType.cost,
    multiple_cost_delete = moduleType.organizer_console + subModuleType.multiple_cost_delete,

    //quotes state
    default_quotes_states_colors = moduleType.organizer_console + subModuleType.default_quotes_states_colors,

    //task
    task = moduleType.organizer_console + subModuleType.task,
    multiple_task = moduleType.organizer_console + subModuleType.multiple_task_delete,
    group_task = moduleType.organizer_console + subModuleType.group_task,
    task_client_rate = moduleType.organizer_console + subModuleType.task_client_custom_rates,
    task_staff_custom_rates = moduleType.organizer_console + subModuleType.task_staff_custom_rates,
    task_staff_billing_rates = moduleType.organizer_console + subModuleType.task_staff_billing_rates,
    task_client_billing_rates = moduleType.organizer_console + subModuleType.task_client_billing_rates,
    //staff
    staff = moduleType.organizer_console + subModuleType.staff,
    staff_task_billing_rates = moduleType.organizer_console + subModuleType.staff_task_billing_rates,
    staff_rate_history = moduleType.organizer_console + subModuleType.staff_rate_history,
    multiple_staff_history_delete = moduleType.organizer_console + subModuleType.multiple_staff_history_delete,
    staff_resend_email_invitation = moduleType.organizer_console + subModuleType.staff_resend_email_invitation,

    //stafftaskrates
    staff_task_rates = moduleType.organizer_console + subModuleType.staff_custom_rates,

    //UserAccess
    user_access_permission = moduleType.organizer_console + subModuleType.user_access_permission,
    staff_access_permission = moduleType.organizer_console + subModuleType.staff_access_permission,
    client_access_permission = moduleType.organizer_console + subModuleType.client_access_permission,

    //staff-teams
    teamlist = moduleType.organizer_console + subModuleType.team,

    //custom-fields
    custom_field_type = moduleType.features + subModuleType.ddl + subModuleType.custom_field_type,
    custom_field_usage = moduleType.features + subModuleType.ddl + subModuleType.custom_field_usage,
    custom_list = moduleType.features + subModuleType.custom_field,
    get_custom_fields = moduleType.features + subModuleType.custom_field,
    custom_field_usage_patch = moduleType.features + subModuleType.custom_field_usage,
    multiple_custom_field_delete = moduleType.features + subModuleType.multiple_custom_field_delete,

    //emailTemplate
    external_email_template = moduleType.features + subModuleType.external_email_template,
    multiple_external_template_delete = moduleType.features + subModuleType.multiple_external_email_templates_delete,
    multiple_email_templates_delete = moduleType.features + subModuleType.multiple_email_templates_delete,

    //InternalEmailTemplate
    internal_email_template = moduleType.worksheet + subModuleType.internal_email_template,
    email_template = moduleType.features + subModuleType.email_template,
    invoice_logo = moduleType.organizer_console + subModuleType.invoice_image_upload + subModuleType.invoice_logo,
    invoice_image_delete_file = moduleType.organizer_console + subModuleType.invoice_image_delete_file,
    custom_templates = moduleType.organizer_console + subModuleType.custom_templates,
    invocie_settings = moduleType.organizer_console + subModuleType.invoice_settings,
    custom_template_pdf_view = moduleType.organizer_console + subModuleType.custom_template_pdf_view,
    //collaboration -jobs
    jobslist = moduleType.collaboration + subModuleType.job,
    jobstasklist = moduleType.collaboration + subModuleType.jobstask,
    jobsddl = moduleType.collaboration + subModuleType.ddl + subModuleType.job,
    jobtask = moduleType.collaboration + subModuleType.ddl + subModuleType.job_task_ddl,
    jobstate = moduleType.collaboration + subModuleType.ddl + subModuleType.job_states,
    job_priority = moduleType.worksheet + subModuleType.ddl + subModuleType.job_priority,
    jobstodolist = moduleType.collaboration + subModuleType.jobtasktodo,
    jobstimesheetlist = moduleType.collaboration + subModuleType.jobtimesheet,
    jobsstaff_ddl = moduleType.collaboration + subModuleType.ddl + subModuleType.job_staffs,
    jobstimesheet = moduleType.collaboration + subModuleType.timesheet,
    jobscost = moduleType.collaboration + subModuleType.job_cost,
    jobs_quotes = moduleType.collaboration + subModuleType.job_quotes,
    jobs_invoice = moduleType.collaboration + subModuleType.invoice,
    jobs_po = moduleType.collaboration + subModuleType.job_po,
    jobs_task_ddl = moduleType.collaboration + subModuleType.ddl + subModuleType.job_staff_task,
    jobs_task_staff_ddl = moduleType.collaboration + subModuleType.ddl + subModuleType.job_task_staff,
    jobs_state_type_ddl = moduleType.worksheet + subModuleType.ddl + subModuleType.job_states_type,
    jobs_document = moduleType.collaboration + subModuleType.job_document_upload,
    jobs_documents_folders = moduleType.collaboration + subModuleType.job_documents_folders,
    jobs_documents_folders_documents = moduleType.collaboration + subModuleType.job_documents_folders_documents,
    jobs_notes = moduleType.collaboration + subModuleType.job_notes,
    jobs_folder = moduleType.collaboration + subModuleType.job_folders,
    jobs_folder_notes = moduleType.collaboration + subModuleType.job_folder_notes,
    jobs_task_notes = moduleType.collaboration + subModuleType.job_task_notes,
    jobs_task_folder = moduleType.collaboration + subModuleType.job_task_folders,
    jobs_task_folder_notes = moduleType.collaboration + subModuleType.job_task_folder_notes,
    deleteTask = moduleType.collaboration + subModuleType.job_task,
    deletecost = moduleType.collaboration + subModuleType.job_cost,
    jobs_notes_comments = moduleType.collaboration + subModuleType.job_notes_comments,
    jobs_task_notes_comments = moduleType.collaboration + subModuleType.job_task_notes_comments,
    job_financial_summary = moduleType.collaboration + subModuleType.job_financial_summary,
    job_history = moduleType.collaboration + subModuleType.job_history,
    job_count = moduleType.collaboration + subModuleType.job_count,
    jobs_custom_fields = moduleType.collaboration + subModuleType.job_custom_fields,
    multiple_job_delete = moduleType.collaboration + subModuleType.multiple_job_delete,
    multiple_job_task_delete = moduleType.collaboration + subModuleType.multiple_job_task_delete,
    multiple_job_cost_delete = moduleType.collaboration + subModuleType.multiple_job_cost_delete,
    multiple_timesheet_delete = moduleType.collaboration + subModuleType.multiple_timesheet_delete,
    multiple_job_task_todo_delete = moduleType.collaboration + subModuleType.multiple_job_task_todo_delete,
    job_task_reorder = moduleType.collaboration + subModuleType.job_task_reorder,
    job_cost_reorder = moduleType.collaboration + subModuleType.job_cost_reorder,
    job_staff_billing_rates = moduleType.collaboration + subModuleType.job_staff_billing_rates,
    timesheet_status_update = moduleType.collaboration + subModuleType.timesheet_status_update,
    invoices_ddl = moduleType.collaboration + subModuleType.ddl + subModuleType.invoice,
    job_cost_status_update = moduleType.collaboration + subModuleType.job_cost_status_update,
    timesheet_custom_fields = moduleType.collaboration + subModuleType.timesheet_custom_fields,
    job_phase_ddl = moduleType.collaboration + subModuleType.ddl + subModuleType.job_phase,
    job_phase = moduleType.collaboration + subModuleType.job_phase,
    job_milestones = moduleType.collaboration + subModuleType.job_milestones,
    job_phase_notes = moduleType.collaboration + subModuleType.job_phase_notes,
    job_task_staff_allocation = moduleType.collaboration + subModuleType.job_task_staff_allocation,
    job_phase_items = moduleType.collaboration + subModuleType.job_phase_items,
    job_task_custom_fields = moduleType.collaboration + subModuleType.job_task_custom_fields,
    job_cost_custom_fields =  moduleType.collaboration + subModuleType.job_cost_custom_fields,
    jobs_v2_invoice = moduleType.collaboration + subModuleType.v2 + subModuleType.invoice,

    // version-2
    job_info_version2 = moduleType.collaboration + subModuleType.v2 + subModuleType.invoice_items,

    //business -quotes
    quotes = moduleType.business + subModuleType.quotes,
    quotes_cost = moduleType.business + subModuleType.quotes_cost,
    quotes_cost_margin = moduleType.business + subModuleType.quotes_cost_margin,
    quotes_option_margin = moduleType.business + subModuleType.quotes_option_margin,
    quotes_options = moduleType.business + subModuleType.quotes_options,
    quotes_multi = moduleType.business + subModuleType.quotes_cost_multi,
    tax_ddl = moduleType.business + subModuleType.ddl + subModuleType.tax,
    quotes_type_ddl = moduleType.worksheet + subModuleType.ddl + subModuleType.quotes_types,
    quotes_template_ddl = moduleType.business + subModuleType.ddl + subModuleType.job_template,
    get_clientCrates = moduleType.business + subModuleType.quotes + subModuleType.clients,
    get_quotestask = moduleType.business + subModuleType.quotes_task,
    gettax1_ddl = moduleType.business + subModuleType.ddl + subModuleType.tax,
    grouptask_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.group_task,
    mutliple_task = moduleType.business + subModuleType.quotes_multiple_task,
    quotes_notes = moduleType.business + subModuleType.quotes_notes,
    quotes_folders = moduleType.business + subModuleType.quotes_folders,
    quotes_folder_notes = moduleType.business + subModuleType.quotes_folder_notes,
    quotes_history = moduleType.business + subModuleType.quotes_history,
    quotes_accept_info = moduleType.business + subModuleType.quotes_accept_info,
    quotes_archive = moduleType.business + subModuleType.quotes_archive,
    quotes_document_upload = moduleType.business + subModuleType.quotes_document_upload,
    quotes_documents_folders = moduleType.business + subModuleType.quotes_documents_folders,
    quotes_documents_folders_documents = moduleType.business + subModuleType.quotes_documents_folders_documents,
    getquotesstate_ddl = moduleType.organizer_console + subModuleType.ddl + subModuleType.quotes_states,
    quotes_issue_accept = moduleType.business + subModuleType.quotes_issue_and_accept,
    quotes_state = moduleType.organizer_console + subModuleType.quotes_states,
    quotes_notes_comments = moduleType.business + subModuleType.quotes_notes_comments,
    quotes_custom_fields = moduleType.business + subModuleType.quotes_custom_fields,
    quotes_count = moduleType.business + subModuleType.quotes_count,
    quotes_option_task = moduleType.business + subModuleType.quotes_option_task,
    quotes_option_cost = moduleType.business + subModuleType.quotes_option_cost,
    multiple_quotes_delete = moduleType.business + subModuleType.multiple_quotes_delete,
    multiple_quotes_task_delete = moduleType.business + subModuleType.multiple_quotes_task_delete,
    multiple_quotes_expense_delete = moduleType.business + subModuleType.multiple_quotes_expense_delete,
    quotes_task_reoder = moduleType.business + subModuleType.quotes_task_reoder,
    quotes_cost_reoder = moduleType.business + subModuleType.quotes_cost_reoder,
    quotes_send_email = moduleType.worksheet + subModuleType.send_email,
    quotes_ddl = moduleType.business +subModuleType.ddl + subModuleType.quotes,
    quotes_phase = moduleType.business +subModuleType.ddl + subModuleType.quotes_phase,
    quote_phase = moduleType.business + subModuleType.quotes_phase,
    quotes_rate_source = moduleType.business + subModuleType.quotes_rate_source,
    multiple_quotes_rate_source = moduleType.business + subModuleType.multiple_quotes_rate_source,
    quotes_phase_notes = moduleType.business + subModuleType.quotes_phase_notes,
    quotes_task_staff_allocation = moduleType.business + subModuleType.quotes_task_staff_allocation,
    quotes_phase_items = moduleType.business + subModuleType.quotes_phase_items,

    //interactions

    clients = moduleType.interactions + subModuleType.clients,
    clientcontact = moduleType.interactions + subModuleType.ddl + subModuleType.client,
    contact = subModuleType.contact,
    supplier = moduleType.interactions + subModuleType.supplier,

    client_contact = moduleType.interactions + subModuleType.client_contact,
    client_notes = moduleType.interactions + subModuleType.client_notes,
    client_list = moduleType.interactions + subModuleType.client_list,
    client_folder = moduleType.interactions + subModuleType.client_folders,
    client_folder_notes = moduleType.interactions + subModuleType.client_folder_notes,
    client_jobs_list = moduleType.interactions + subModuleType.client_job,
    client_quotes_list = moduleType.interactions + subModuleType.client_quotes,
    client_invoice_list = moduleType.interactions + subModuleType.client_invoice,
    client_ddl = moduleType.interactions + subModuleType.ddl + subModuleType.clients,
    client_custom_fields = moduleType.interactions + subModuleType.client_custom_fields,
    client_notes_comments = moduleType.interactions + subModuleType.client_notes_comments,
    client_overview_count = moduleType.interactions + subModuleType.client_overview_count,
    client_staff_billing_rates = moduleType.interactions + subModuleType.client_staff_billing_rates,
    client_task_billing_rates = moduleType.interactions + subModuleType.client_task_billing_rates,
    contacts = subModuleType.contacts,
    client_contact_custom_fields = moduleType.interactions + subModuleType.client_contact_custom_fields,

    supplier_notes = moduleType.interactions + subModuleType.supplier_notes,
    supplier_folder = moduleType.interactions + subModuleType.supplier_folders,
    supplier_folder_notes = moduleType.interactions + subModuleType.supplier_folder_notes,
    supplier_contact = moduleType.interactions + subModuleType.supplier_contact,
    supplier_cost = moduleType.interactions + subModuleType.supplier_cost,
    supplier_po = moduleType.interactions + subModuleType.supplier_po,
    supplier_document = moduleType.interactions + subModuleType.supplier_document_upload,
    supplier_documents_folders = moduleType.interactions + subModuleType.supplier_documents_folders,
    supplier_documents_folders_documents = moduleType.interactions + subModuleType.supplier_documents_folders_documents,

    staff_ddl = moduleType.authentication + subModuleType.ddl + subModuleType.userprofile,

    balance_month = moduleType.interactions + subModuleType.ddl + subModuleType.balance_month,
    business_structure = moduleType.interactions + subModuleType.ddl + subModuleType.business_structure,
    ddl_client_type = moduleType.interactions + subModuleType.ddl + subModuleType.client_type,
    client_document = moduleType.interactions + subModuleType.client_document_upload,
    client_documents_folders = moduleType.interactions + subModuleType.client_documents_folders,
    client_documents_folders_documents = moduleType.interactions + subModuleType.client_documents_folders_documents,
    client_tasks_custom_rates = moduleType.interactions + subModuleType.client_tasks_custom_rates,
    clients_address = moduleType.interactions + subModuleType.client_address,
    clients_overview = moduleType.interactions + subModuleType.client_overview,

    //invoices
    invoice = moduleType.collaboration + subModuleType.invoices,
    miscellaneous_invoice = moduleType.collaboration + subModuleType.miscellaneous_invoice,
    invoice_list = moduleType.collaboration + subModuleType.invoice_list,
    invoice_job_charges = moduleType.collaboration + subModuleType.invoice_job_charges,
    invoice_charges = moduleType.collaboration + subModuleType.invoice_charges,
    invoice_notes_list = moduleType.collaboration + subModuleType.invoice_notes,
    invoice_notes = moduleType.collaboration + subModuleType.invoice_notes,
    invoice_folders = moduleType.collaboration + subModuleType.invoice_folders,
    invoice_folders_notes = moduleType.collaboration + subModuleType.invoice_folder_notes,
    invoice_task = moduleType.collaboration + subModuleType.invoice_task,
    invoice_cost = moduleType.collaboration + subModuleType.invoice_cost,
    // invoice_payment = moduleType.collaboration + subModuleType.invoice_payment,
    invoice_due = moduleType.collaboration + subModuleType.invoice_due,
    invoice_timesheet = moduleType.collaboration + subModuleType.invoice_timesheet,
    invoice_notes_comments = moduleType.collaboration + subModuleType.invoice_notes_comments,
    invoice_sub_type_list = moduleType.collaboration + subModuleType.invoice_sub_type_list,
    invoice_quotes_amount = moduleType.collaboration + subModuleType.invoice_quotes_amount,
    invoice_overview = moduleType.collaboration + subModuleType.invoice_overview,
    invoice_payment_write_off = moduleType.collaboration + subModuleType.invoice_payment_write_off,
    invoice_custom_fields = moduleType.collaboration + subModuleType.invoice_custom_fields,
    invoice_task_reoder = moduleType.collaboration + subModuleType.invoice_task_reorder,
    invoice_cost_reoder = moduleType.collaboration + subModuleType.invoice_cost_reorder,
    invoice_charges_reoder = moduleType.collaboration + subModuleType.invoice_charges_reorder,
    multiple_invoice_cost_delete = moduleType.collaboration + subModuleType.multiple_invoice_cost_delete,
    multiple_invoice_task_delete = moduleType.collaboration + subModuleType.multiple_invoice_task_delete,
    invoice_payment = moduleType.collaboration + subModuleType.invoice_payment,
    client_based_job = moduleType.collaboration + subModuleType.client_based_job,
    v2_invoice = moduleType.collaboration + subModuleType.v2 + subModuleType.invoice,
    invoice_jobs = moduleType.collaboration + subModuleType.ddl + subModuleType.invoice_jobs,
    v2_invoice_list = moduleType.collaboration + subModuleType.v2 + subModuleType.invoice_list,
    invoice_blob = moduleType.collaboration + subModuleType.invoice_blob,
    default_custom_templates = moduleType.worksheet + subModuleType.default_custom_templates,
    // app settings
    appSettings = subModuleType.app_settings,

    //weekly-timesheet
    weekly_timesheet = moduleType.collaboration + subModuleType.weekly_timesheet,
    timesheet_rate = moduleType.collaboration + subModuleType.timesheet_rate,

    //Timesheet Lock
    timesheet_locking = moduleType.collaboration + subModuleType.timesheet_locking,
    timesheet_locking_staff_delete = moduleType.collaboration + subModuleType.timesheet_locking_staff_delete,

    // notifications
    notification = moduleType.features + subModuleType.notification,
    notification_count = moduleType.features + subModuleType.notification_count,
    notification_read_all = moduleType.features + subModuleType.notification_read_all,

    // multilevelapproval
    multi_approval_level = moduleType.organizer_console + subModuleType.multi_approval_level,
    user_multi_approval_level = moduleType.organizer_console + subModuleType.user_multi_approval_level,

    // payments
    client_payment_transaction = moduleType.collaboration + subModuleType.client_payment_transaction,
    invoice_payment_transaction = moduleType.collaboration + subModuleType.invoice_payment_transaction,
    client_invoice = moduleType.collaboration + subModuleType.client_invoice,
    client_payment_detail = moduleType.collaboration + subModuleType.client_payment_detail,
    invoice_adjustment_transaction = moduleType.collaboration + subModuleType.invoice_adjustment_transaction,
    invoice_refund_transaction = moduleType.collaboration + subModuleType.invoice_refund_transaction,

    //billing history
    billing_history_list = moduleType.collaboration + subModuleType.billing_history,
}